module.exports = __webpack_public_path__ + "6065fa1603db028d536d816207b2537f.svg";